module.exports = __webpack_public_path__ + "img/complete_end.be65a136.png";